import { heroFeatured, liveTicker, hotStats } from "@/mocks/trends";

export default function Hero() {
  const trendIcon = {
    up: { cls: "ri-arrow-up-line", color: "text-primary-600" },
    down: { cls: "ri-arrow-down-line", color: "text-secondary-600" },
    new: { cls: "ri-sparkling-line", color: "text-accent-600" },
    flat: { cls: "ri-subtract-line", color: "text-foreground-400" },
  } as const;
  const ic = trendIcon[heroFeatured.trend];

  return (
    <section id="live" className="relative w-full">
      <div className="mx-auto w-full max-w-6xl px-4 pb-4 pt-8 md:px-6 md:pt-10">
        {/* 主视觉瓜王卡片 */}
        <div className="grid gap-5 lg:grid-cols-12">
          <div className="relative overflow-hidden rounded-2xl lg:col-span-8">
            <img
              src="https://readdy.ai/api/search-image?query=concept%20of%20breaking%20trending%20news%20explosion%20with%20fire%20and%20energy%2C%20crowds%20watching%20phones%20at%20night%20concert%20with%20vivid%20stage%20light%2C%20dynamic%20documentary%20photography%2C%20warm%20red%20orange%20gold%20tones%2C%20cinematic%20atmosphere&width=1200&height=760&seq=hero-gua-x1&orientation=landscape"
              alt="今日最热娱乐瓜料——演唱会抢票现场热烈气氛"
              className="h-full w-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent"></div>
            <div className="absolute inset-x-0 bottom-0 p-5 md:p-7">
              <div className="flex flex-wrap items-center gap-2">
                <span className="rounded-full bg-primary-500 px-3 py-1 text-xs font-bold text-background-50">{heroFeatured.tag}</span>
                <span className="rounded-full bg-white/15 px-3 py-1 text-xs font-medium text-white backdrop-blur-sm">{heroFeatured.category}</span>
              </div>
              <h1 className="mt-3 text-xl font-bold leading-snug text-white md:text-3xl">{heroFeatured.title}</h1>
              <p className="mt-2 hidden max-w-2xl text-sm text-white/80 md:block">{heroFeatured.desc}</p>
              <div className="mt-4 flex flex-wrap items-center gap-4">
                <span className="flex items-center gap-1.5 text-sm text-white">
                  <i className={`${ic.cls} ${ic.color} text-lg`}></i>
                  <b className="font-heading text-base text-accent-300">{heroFeatured.heat}</b>
                </span>
                <span className="flex items-center gap-1.5 text-sm text-white">
                  <i className="ri-chat-3-line text-lg text-white/80"></i>
                  {heroFeatured.discuss}
                </span>
                <a
                  href="#hotpick"
                  onClick={(e) => {
                    e.preventDefault();
                    document.getElementById("hotpick")?.scrollIntoView({ behavior: "smooth" });
                  }}
                  className="ml-auto rounded-md bg-accent-400 px-4 py-2 text-sm font-bold text-foreground-950 transition hover:bg-accent-300"
                >
                  看完整瓜料 <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            </div>
          </div>

          {/* 侧边实时热搜 */}
          <div className="flex flex-col rounded-2xl border border-background-200 bg-background-100 p-4 md:p-5 lg:col-span-4">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                <span className="relative flex h-2.5 w-2.5">
                  <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-primary-500 opacity-75"></span>
                  <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-primary-500"></span>
                </span>
                <h2 className="text-base font-bold text-foreground-950">实时热搜 · 刚刚</h2>
              </div>
              <span className="font-heading text-xs text-foreground-500">MINUTE LIVE</span>
            </div>
            <ul className="mt-3 flex flex-1 flex-col justify-between gap-2">
              {liveTicker.slice(0, 7).map((t, i) => (
                <li
                  key={i}
                  className="group flex cursor-pointer items-center gap-3 rounded-lg px-2 py-1.5 transition hover:bg-background-50"
                >
                  <span className={`font-heading text-lg font-semibold ${i < 3 ? "text-primary-500" : "text-foreground-300"}`}>
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <span className="flex-1 truncate text-sm text-foreground-800 group-hover:text-primary-700">{t}</span>
                  <i className="ri-arrow-up-line text-xs text-primary-500"></i>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* 数据横幅 */}
        <div className="mt-6 grid grid-cols-2 gap-3 md:grid-cols-4 md:gap-4">
          {hotStats.map((s) => (
            <div key={s.label} className="flex items-center gap-3 rounded-xl bg-background-100 px-4 py-3">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-accent-100 text-accent-700">
                <i className={`${s.icon} text-lg`}></i>
              </span>
              <div className="leading-tight">
                <div className="font-heading text-xl font-semibold text-foreground-950">{s.value}</div>
                <div className="text-xs text-foreground-500">{s.label}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}